import { ReactNode } from 'react'
import { Backdrop, useTheme } from '@mui/material'

import { StyledBox } from 'presentation/components/elements/backdropPopup/index.styled'

type BackdropPopupProps = {
  openBackdrop: boolean
  children: ReactNode | ReactNode[]
  padding?: string
}

export default function BackdropPopup({ openBackdrop, children, padding }: BackdropPopupProps) {
  const theme = useTheme()
  return (
    <Backdrop open={openBackdrop} sx={{ zIndex: 1500 }}>
      <StyledBox padding={padding} theme={theme}>
        {children}
      </StyledBox>
    </Backdrop>
  )
}
